export enum ZONE {
  US = 'US',
  EU = 'EU',
  SEA = 'SEA',
}

export enum STATUS {
  OPERATIONAL = 'operational',
  DEGRADED = 'degraded',
  OUTAGE = 'outage',
  MAINTENANCE = 'maintenance',
}

export enum TIME_RANGE {
  LAST_24_HOURS = '24h',
  LAST_7_DAYS = '7d',
  LAST_30_DAYS = '30d',
  LAST_90_DAYS = '90d',
}

export enum SERVICE_TYPE {
  WEB_APP = 'web-app',
  GATEWAY = 'gateway',
  SERVICE = 'service',
  DATABASE = 'database',
  CACHE = 'cache',
}
